import {
  AfterViewChecked,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  standalone: false,
})
export class ModalDialogComponent implements OnInit, AfterViewChecked {
  @Input() containerID: string;
  @Input() modalMaxWidth: string;
  @Output() sendClick = new EventEmitter<boolean>();
  element: ElementRef;

  // The content child allows to inject custom content into the modal container
  @ContentChild('modalContainer', { static: true }) contentElement: ElementRef;

  // NOTE: This element is the dom element for the modal dialog component
  @ViewChild('modalDialog') parentElement: ElementRef;

  constructor() {}

  /**
   * Default OnInit
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Set the view child element after view checked so we can use this element to hide and close
   * the modal dialog
   */
  ngAfterViewChecked(): void {
    this.element = this.parentElement;
  }

  /**
   * Open Modal
   * Get the native element from Element Reference to show the block.
   */
  openModal(): void {
    if (this.element) {
      this.element.nativeElement.style.display = 'block';
    }
  }

  /**
   * Close Modal
   * Get the native element from Element Reference to hide the block.
   * @param emitFlag - emitFlag used when we dont want to emit while closing the Modal (optional). Currently this flag is used in ConfirmDialog Component.
   */
  closeModal(emitFlag?: boolean): void {
    if (this.element) {
      this.element.nativeElement.style.display = 'none';
      !emitFlag ? this.sendClick.emit(true) : '';

      // Update document body styling so background does not scroll when modal is open
      // TODO : Revisit this place why are we doing this unlockBackgroundScrolling.
      //unlockBackgroundScrolling();
    }
  }
}
